export default __webpack_public_path__ + "static/media/Aarom.095dd339.png";